var exports = {
  "k": "x0a7806d5--e5fa1f--container",
  "X": "x0a7806d5--e5fa1f--scroller",
};

module.exports = exports;
